module.exports = __webpack_public_path__ + "static/presidents-message-c76d156fa7b365a3162e81346f50abd1.jpg";